// import styled from 'styled-components';
// import { Container } from '@mui/material';

import styled from 'styled-components';

// export const StyledEnvironment = styled(Container)`
//   .environment-wrapper {
//     &-top {
//       width: 100%;
//       height: 100%;
//       display: flex;
//       gap: 24px;
//       margin-bottom: 24px;

//       &-left {
//         width: 50%;

//         &-header {
//           display: flex;
//           justify-content: space-between;
//           gap: 24px;
//           align-items: center;
//           padding-bottom: 12px;
//           height: 54px;
//           border-bottom: 1px solid #dadada;

//           &-title {
//             font-weight: 600;
//             font-size: 20px;
//             color: #2f2f35;
//           }

//           &-date {
//           }
//         }

//         &-content {
//           display: flex;
//           flex-wrap: wrap;
//           margin-top: 24px;

//           > div {
//             flex: 0 0 25%;
//             box-sizing: border-box;
//             padding: 10px;

//             &:nth-child(1) {
//               flex: 0 0 50%;
//             }
//           }
//         }
//       }

//       &-right {
//         width: 50%;

//         &-header {
//           display: flex;
//           justify-content: space-between;
//           gap: 24px;
//           align-items: center;
//           margin-left: 24px;
//           padding-bottom: 12px;
//           height: 54px;
//           border-bottom: 1px solid #dadada;

//           &-title {
//             font-weight: 600;
//             font-size: 20px;
//             color: #2f2f35;
//           }

//           &-date {
//             font-weight: 600;
//             font-size: 20px;
//             color: #9c9c9c;
//           }
//         }

//         &-content {
//           display: flex;
//           flex-wrap: wrap;
//           margin-top: 24px;

//           > div {
//             flex: 0 0 25%;
//             box-sizing: border-box;
//             padding: 10px;

//             &:nth-child(1) {
//               flex: 0 0 50%;
//             }
//           }
//         }
//       }
//     }
//   }

//   @media (max-width: 1340px) {
//     .environment-wrapper {
//       &-top {
//         &-left {
//           &-content {
//             > div {
//               flex: 0 0 100%;
//             }
//           }
//         }

//         &-right {
//           &-content {
//             > div {
//               flex: 0 0 50%;
//             }
//           }
//         }
//       }
//     }
//   }

//   @media (max-width: 880px) {
//     .environment-wrapper {
//       &-top {
//         &-right {
//           &-content {
//             > div {
//               flex: 0 0 100%;

//               &:nth-child(1) {
//                 flex: 0 0 100%;
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// `;

export const StyledEnvironment = styled.div``;

export const EnvironmentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const EnvironmentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EnvironmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  border-bottom: 1px solid #dadada;
  padding-bottom: 8px;

  .title {
    font-weight: 600;
    font-size: 20px;
    color: #2f2f35;
  }

  .date {
    font-weight: 500;
    font-size: 20px;
    color: #9c9c9c;
  }
`;
